import PropTypes from 'prop-types'
import isNil from 'lodash/isNil'
import transformProp from 'loankeeper-common/containers/transformProp'
import ChainEnd from './ChainEnd'

const transformOptions = (options) =>
  options.map(({ key, text, value }) => ({
    key: !isNil(key) ? key : value,
    text: !isNil(text) ? text : value,
    value,
  }))

const OptionsProp = transformProp('options', transformOptions)(ChainEnd)

OptionsProp.defaultProps = {
  options: [],
  disabled: false,
  openOnFocus: true,
}

const stringOrNumberType = PropTypes.oneOfType([PropTypes.string, PropTypes.number])

OptionsProp.propTypes = {
  disabled: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.shape({
        value: stringOrNumberType.isRequired,
      }),
      PropTypes.shape({
        text: stringOrNumberType.isRequired,
        value: stringOrNumberType.isRequired,
      }),
    ]),
  ),
  openOnFocus: PropTypes.bool,
}

export default OptionsProp
